const drawer = {
  parts: ['dialog', 'header', 'body', 'footer'],
  baseStyle: {
    overlay: {
      bg: 'blackAlpha.800',
    },
    dialog: {
      margin: ['0px', '0px', '10px 20px 10px', '10px 20px 10px'],
      borderRadius: '10px',
      minHeight: '100dvh',
    },
    body: {
      padding: 4,
      bg: 'bgContainer',
    },
    header: {
      bg: 'light',
      fontWeight: 500,
      borderBottomWidth: '1px',
      borderColor: 'borderColor',
      borderTopRadius: '10px',
    },

    footer: {
      bg: 'light',
      borderTopWidth: '1px',
      borderColor: 'borderColor',
      borderBottomRadius: '10px',
      gap: 4,
      paddingBottom: [
        'calc(env(safe-area-inset-bottom) + 90px)',
        'calc(env(safe-area-inset-bottom) + 90px)',
        '16px',
        '16px',
      ],
    },
  },
  sizes: {
    full: {
      overlay: {
        bg: 'blackAlpha.800',
      },
      dialog: {
        margin: '0px',
        borderRadius: '0px',
      },
      header: {
        borderTopRadius: '0px',
      },
      footer: {
        borderBottomRadius: '0px',
      },
    },
  },
  variants: {},
  defaultProps: {
    size: 'md',
  },
}

export default drawer
